module.exports = __webpack_public_path__ + "static/media/plane.a69a4ee6.jpg";